import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import { mapCalculatorAccess } from "web_myplann/Calculators/Utils/mapCalculatorAccess";
import { getCalculatorAccess } from "web_myplann/Infrastructure/ApiOld/Api";

export const useLegacyCalculatorAccessQuery = () =>
	useQuery({
		queryKey: CalculatorKeys.legacyAccess(),
		queryFn: () => getCalculatorAccess(),
		select: (response) =>
			mapCalculatorAccess(
				response?.status === 200 ? (response.data?.data?.items ?? []) : [],
			),
	});
